import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Box, styled } from '@material-ui/core';
import ReactTelephoneInput from 'react-telephone-input';
import 'react-telephone-input/css/default.css';
import { isNotNillNorEmpty } from '../../../../utils/helpers';
import messages from '../messages';
import flagsImagePath from './flags.png';

const TelephoneStyledWrapper = styled(Box)(({ preferred, all, hasPreferredCountries }) => ({
  top: '18px',
  '& input[type="tel"]': {
    display: 'none',
  },
  '& .flag-dropdown': {
    border: 'none !important',
  },
  '& .selected-flag': {
    border: 'none',
    background: 'none',
  },
  '& + div input': {
    marginLeft: 45,
  },
  '& .country-list > div': {
    marginTop: hasPreferredCountries ? '40px' : '0px',
  },
  '& .preferred:first-of-type': {
    height: '80px !important',
    marginTop: '-40px',
    '&:before': {
      content: `'${preferred}'`,
      display: 'block',
      fontWeight: 'bold',
      padding: '5px 10px 10px',
      margin: '-5px -10px 5px',
      backgroundColor: '#fff',
    },
  },
  '& div[data-country-code="af"]:not(.preferred:first-child)': {
    height: '80px !important',
    '&:before': {
      content: `'${all}'`,
      display: 'block',
      fontWeight: 'bold',
      padding: '5px 10px 10px',
      margin: '-5px -10px 5px',
      backgroundColor: '#fff',
    },
    '& ~ div': {
      marginTop: '40px',
    },
  },
}));

const CountrySelector = ({ onChange, value, preferredCountries }) => {
  const intl = useIntl();
  const hasPreferredCountries = isNotNillNorEmpty(preferredCountries);

  return (
    <TelephoneStyledWrapper
      preferred={intl.formatMessage(messages.preferred)}
      all={intl.formatMessage(messages.all)}
      hasPreferredCountries={hasPreferredCountries}
    >
      <ReactTelephoneInput
        className="country-selector"
        autoFormat={false}
        defaultCountry={value}
        value={value}
        flagsImagePath={flagsImagePath}
        onChange={(dial, { iso2 }) => onChange(iso2)}
        preferredCountries={preferredCountries}
      />
    </TelephoneStyledWrapper>
  );
};

CountrySelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  preferredCountries: PropTypes.array,
};

export default CountrySelector;
